import React from 'react';
import Button from '../../button/button';

const ThankYouButton = (props) => {
    let { type, children, after, before, gray, large, mb1, ml1 } = props;
    return (
		<Button type="hero" gray={gray} large={large} mb1={mb1} ml1={ml1} before={before} after={after} onClick={() => {
			window.open( astraSitesVars.siteURL, '_blank' );
		}}>{children}</Button>
	)
}

export default ThankYouButton;
